import { createFileRoute, Navigate } from "@tanstack/react-router";
import { routePath } from "#app/lib/hooks/use-app-navigate";

function SettingsIndex() {
  const { workspace } = Route.useParams();
  return <Navigate to={routePath(`/${workspace}/settings/preferences`)} />;
}

export const Route = createFileRoute("/(app)/$workspace/settings/")({
  component: SettingsIndex,
});
